import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';

import { get } from 'helpers/api';

export default class ImportProgress extends React.Component {
  static propTypes = {
    fileName: PropTypes.string.isRequired,
    importJobId: PropTypes.number.isRequired,
    objectName: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired
  }

  state = {
    intervalId: null,
    progress: 0
  }

  componentDidMount() {
    this.setState({ intervalId: setInterval(this.checkProgress, 2000) });
  }

  handleComplete(summary) {
    clearInterval(this.state.intervalId);
    this.props.onComplete(summary);
  }

  checkProgress = () => {
    get(`/import_jobs/${this.props.importJobId}`).then(({ complete, progress, summary }) => {
      complete ? this.handleComplete(summary) : this.setState({ progress });
    });
  }

  render() {
    const { fileName, objectName } = this.props;
    const { progress } = this.state;

    return (
      <React.Fragment>
        <h4 className="mb-4 mt-5 text-uppercase text-muted">
          <strong>{fileName}</strong>
        </h4>
        <div className="py-5 import-progress">
          <ProgressBar active className="w-90 mb-4" now={progress} />
          <h4 className="m-0">{Math.round(progress)}% of {objectName} imported</h4>
        </div>
      </React.Fragment>
    );
  }
}
